import { filterId } from 'app/area/search-filters/constants';
import { SerializePayload } from 'app/area/search-filters/types';
import { FilterSearchModel } from 'app/area/search-filters/types-store';

export const serializeQuery = (query: string) => {
  return query && query.trim().length
    ? {
      [filterId.query]: {
        text: query.trim()
      }
    }
    : {};
};

export const serialize = (dataToSerialize: SerializePayload): FilterSearchModel => {
  const { query } = dataToSerialize;
  return {
    ...serializeQuery(query)
  };
};
